module.exports = __webpack_public_path__ + "img/tortilla.05660b14.jpg";